import { createContext, useContext, useEffect, useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import toast from "react-hot-toast";
import socket from "./socketService.js";
import logoImage from './assets/images/logo.png';

// Create Context
const NotificationContext = createContext();

// Provider Component
export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // Request Notification Permission when the app starts
    if ("Notification" in window) {
      Notification.requestPermission();
    }

    // Connect to socket
    socket.connect();

    // Listen for "newUser" event
    socket.on("newUser", (order) => {
      // Extract message from the notification data
      const message = order?.data?.notification?.body || "New user registered";
      const notificationData = { message };
      setNotifications((prev) => [...prev, notificationData]);
      toast.success(`${message}`);

      // Show browser notification if tab is inactive
      if (Notification.permission === "granted") {
        const notification = new Notification(order?.data?.notification?.title || "New User", {
          body: order?.data?.notification?.body || "A new user has registered",
          icon: logoImage,
        });

        // Click on notification opens the app
        notification.onclick = () => {
          window.focus();
        };
      }
    });

    // Listen for "newResult" event
    socket.on("newResult", (order) => {
      const { message } = order?.data?.notification?.body || "New Result";
      const notificationData = { message };
      setNotifications((prev) => [...prev, notificationData]);
      toast.success(`${message}`);

      if (Notification.permission === "granted") {
        const notification = new Notification(order?.data?.notification?.title || "New Result", {
          body: order?.data?.notification?.body  || "A new result has created" ,
          icon: logoImage,
        });

        notification.onclick = () => {
          window.focus();
        };
      }
    });

    // Listen for "gallery" event
    // socket.on("gallery", (order) => {
    //   const { message } = order.data;
    //   const notificationData = { message };
    //   setNotifications((prev) => [...prev, notificationData]);
    //   toast.success(`${message}`);

    //   if (Notification.permission === "granted") {
    //     const notification = new Notification(order.data.subject, {
    //       // body: order?.data?.notification?.body,
    //       icon: logoImage,
    //     });

    //     notification.onclick = () => {
    //       window.focus();
    //     };
    //   }
    // });

    // Listen for "entertainment" event
    // socket.on("entertainment", (order) => {
    //   const { message } = order.data;
    //   const notificationData = { message };
    //   setNotifications((prev) => [...prev, notificationData]);
    //   toast.success(`${message}`);

    //   if (Notification.permission === "granted") {
    //     const notification = new Notification(order.data.notification.title, {
    //       body: order.data.notification.body,
    //       icon: logoImage,
    //     });

    //     notification.onclick = () => {
    //       window.focus();
    //     };
    //   }
    // });

    // Listen for "messageCreated" event
    // socket.on("messageCreated", (order) => {
    //   const { message } = order.data;
    //   const notificationData = { message };
    //   setNotifications((prev) => [...prev, notificationData]);
    //   toast.success(`${message}`);

    //   if (Notification.permission === "granted") {
    //     const notification = new Notification(order.data.subject, {
    //       body: order.data.message,
    //       icon: logoImage,
    //     });

    //     notification.onclick = () => {
    //       window.focus();
    //     };
    //   }
    // });

  

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <NotificationContext.Provider value={{ notifications }}>
      {children}
      {/* <ToastContainer /> */}
    </NotificationContext.Provider>
  );
};

// Custom hook to use notifications
export const useNotification = () => useContext(NotificationContext);
